// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms {
  font-size: 14px;
  color: #234879 !important;
  text-decoration: underline !important;
  white-space: pre-wrap;
}

.largeIconWithPadding {
  font-size: 60px !important;
  padding-top: 20px;
}

.alignItemCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/verify-OTP/verify-otp/verify-otp.page.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,yBAAA;EACA,qCAAA;EACA,qBAAA;AACJ;;AACE;EACE,0BAAA;EACA,iBAAA;AAEJ;;AAAE;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEJ","sourcesContent":[".terms {\n    font-size: 14px;\n    color: #234879 !important;\n    text-decoration: underline !important;\n    white-space: pre-wrap;\n  }\n  .largeIconWithPadding {\n    font-size: 60px !important;\n    padding-top: 20px;\n  }\n  .alignItemCenter\n  {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
